import React, {useEffect, useState} from "react";
import styled from "styled-components";

import LocationFilterIcon from "../../Components/DirectoryPanel/svg/LocationFilterIcon.svg";
import {Configure} from "react-instantsearch-dom";
import {useTranslation} from "react-i18next";

const InputIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11.641"
        height="16.629"
        viewBox="0 0 11.641 16.629"
    >
        <path
            id="ic_place_24px"
            data-name="ic place 24px"
            d="M479.535,144.148a5.816,5.816,0,0,0-5.82,5.812v.009c0,4.365,5.82,10.809,5.82,10.809s5.82-6.444,5.82-10.809a5.815,5.815,0,0,0-5.812-5.82Zm0,7.9a2.079,2.079,0,1,1,2.079-2.079A2.079,2.079,0,0,1,479.535,152.047Z"
            transform="translate(-473.715 -144.148)"
            fill="#c0bebb"
        />
    </svg>
);

const LabelContainer = styled.div`
background-color: #fff;
font-family: Open Sans, sans-serif;;
font-size: 16px;
font-weight: bold;
font-stretch: normal;
font-style: normal;
line-height: 1.13;
letter-spacing: normal;
text-align: left;
color: #2c271c;
padding: 18px;
width: 100%;
text-align: left;
border: none;
cursor: pointer;
}`;

const InputContainer = styled.div`
padding-left: 18px;
padding-right: 18px;

:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 15px;
    width: 15px;
    height: 22px;
    background-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="11.641" height="16.629" viewBox="0 0 11.641 16.629"><path id="ic_place_24px" data-name="ic place 24px" d="M479.535,144.148a5.816,5.816,0,0,0-5.82,5.812v.009c0,4.365,5.82,10.809,5.82,10.809s5.82-6.444,5.82-10.809a5.815,5.815,0,0,0-5.812-5.82Zm0,7.9a2.079,2.079,0,1,1,2.079-2.079A2.079,2.079,0,0,1,479.535,152.047Z" transform="translate(-473.715 -144.148)" fill="#c0bebb"/></svg>');

}

}`;

const clearButtonStyle = {
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    fontFamily: 'Open Sans, sans-serif;',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#a26700',
    textDecoration: 'underline',
    marginRight: '20px'

}

export default function LocationFilter(props) {
    const [textInput, setTextInput] = React.useState("");
    const [locationState, setLocationState] = React.useState(null);
    const { t, i18n } = useTranslation();

    let autocomplete;

    let initAutocomplete = () => {
        try {
            autocomplete = new window.google.maps.places.Autocomplete(
                document.getElementById("field-address"),
                {types: ["(regions)"]}
            );
            autocomplete.setFields(["address_component", "geometry"]);
            autocomplete.addListener("place_changed", fillInAddress);
        } catch (e) {
            console.log("window.google.maps.places.Autocomplete", e);
        }
        console.log("autocomplete", autocomplete);
    };

    let fillInAddress = () => {
        // Get the place details from the autocomplete object.
        let inputValue = document.getElementById("field-address").value;

        if (inputValue === "") {
            //stateSearchFilter(null);
            //mapRef.current.setZoom(4);
            console.log("no place");
            return true;
        }

        let place = autocomplete.getPlace();
        console.log("place", place);

        let state_zoom = place.address_components.some((a) => {
            if (a.types.includes("administrative_area_level_1")) {
                return a.short_name;
            }
        });

        let selected_state = place.address_components.filter((a) => {
            if (a.types.includes("administrative_area_level_1")) {
                return true;
            }
        });

        console.log("state_zoom", state_zoom);


        if (state_zoom) {
            let stateLocationFilter = selected_state[0].short_name;
            console.log("stateLocationFilter", stateLocationFilter);
            //stateSearchFilter(stateLocationFilter);
            setLocationState(stateLocationFilter)
        } else {
            console.log("stateLocationFilter", 'NONE');
            setLocationState(null);
        }
    };

    useEffect(() => {
        initAutocomplete()
    }, []);

    const handleChange = (event) => {
        console.log(event);
        //setTextInput(event.target.value);
    };

    const _onClearLocationRefinements = () => {
        // reset location search
        console.log("stateLocationFilter", 'NONE');
        setLocationState(null);
        setTimeout(function(){
            document.getElementById('field-address').value = '';
            document.getElementById('field-address').click();
        }, 500);


    }

    return (
        <React.Fragment>
            {locationState !== null &&
            <Configure filters={"location_state:'" + locationState + "'"}/>
            }

            <div className="form__controls form__controls--city">
                <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 9.4 13.1">
                    <path
                        fill="#C0BEBB"
                        d="M4.7,0C2.2,0,0,2,0,4.6c0,0,0,0,0,0c0,3.4,4.7,8.5,4.7,8.5S9.4,8,9.4,4.6C9.4,2,7.3,0,4.7,0
                                C4.7,0,4.7,0,4.7,0z M4.7,6.2c-0.9,0-1.6-0.8-1.6-1.7S3.9,2.9,4.8,3c0.9,0,1.6,0.8,1.6,1.6C6.4,5.5,5.6,6.2,4.7,6.2z"
                    ></path>
                </svg>

                <input
                    onChange={handleChange}
                    name="field-address"
                    id="field-address"
                    type="text"
                    autoComplete="off"
                    className="field field--icon"
                    placeholder={t('City.State')}
                />
            </div>
            {locationState !== null &&
            <div className="form__controls-clear">
                <button style={clearButtonStyle} onClick={() => _onClearLocationRefinements()}
                        disabled={!locationState}>
                    Clear
                </button>
            </div>
            }


        </React.Fragment>
    );
}
